import { handleActions } from "redux-actions";

import { SCHEMA_REQUEST } from "constants/action-types";

interface IState {
    error?: Error;
    isFetching: boolean;
    result: string[];
}

const initialState: IState = {
    error: undefined,
    isFetching: false,
    result: [],
};

interface ISchemaRequest {
    payload: any;
}

export const schemas = handleActions(
    {
        [SCHEMA_REQUEST]: (state: IState, { payload }: ISchemaRequest): IState => {
            return {
                ...state,
                isFetching: false,
                result: payload,
            };
        },
    } as any,
    initialState
);
